import {memo} from "react";
import {NavLink} from "react-router-dom";
import {useModal} from "../../hooks/useModal";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {shallowEqual, useSelector} from "react-redux";
import {MODALS, selectUser} from "./helpers";
import {SVG_ICON} from "../common/svg/svg-icon";
import {CONSTANTS} from "../../constants/constants";
import {ModalOptions} from "../modals/ModalOptions/ModalOptions";
import {HeaderSelector} from "./HeaderSelector/HeaderSelector";
import {ImageContainer} from "../ImageContainer/ImageContainer";
import s from './Header.module.css';
import {OptionBtn} from "../common/btns/OptionBtn/OptionBtn";

const {M_LANGUAGES_CURRENCY} = MODALS;

const {
  NAMESPACES,
  ROUTES: {
    HOME,
    PROFILE,
    AUTH,
  },
  CONFIG,
} = CONSTANTS;

export const Header = memo(({inversion = false}) => {

  const {t} = useTranslation(NAMESPACES.COMMON);
  const isMobile = useSelector(state => state.layout.isMobile);

  const {isAuth, currency, language, dataPeople} = useSelector(selectUser, shallowEqual);

  const {openModal, openModalWithId, closeModal} = useModal();

  const background = inversion ? "transparent" : "white";
  const color = inversion ? "white" : "var(--color-main)";

  return (
    <>
      <header
        className={s.wrapper}
        style={{background}}
      >
        <div className={s.container}>
          <NavLink
            className={s.title}
            style={{color}}
            to={HOME.path}
          >
            {CONFIG.APP_NAME}
          </NavLink>


          {(language?.TYPE && currency?.TYPE) && (
           <div className={s['btn-options']}>
             <OptionBtn
               width={'max-content'}
               name={`${language?.TYPE} | ${currency?.TYPE}`}
               callback={() => openModalWithId(M_LANGUAGES_CURRENCY)}
               isActive={true}
             />
           </div>
          )}

          {/*<button*/}
          {/*  className={s['btn-options']}*/}
          {/*  onClick={}*/}
          {/*>*/}
          {/*  <p></p>*/}
          {/*</button>*/}

          {!isMobile &&
            <div className={s['profile-block']}>

              {isAuth && (
                <NavLink to={PROFILE.path}>
                  <div className={classNames(s['image-profile'], {'loading-fon': !dataPeople?.image})}>
                    {dataPeople?.image && <ImageContainer id={dataPeople?.image}/>}
                  </div>
                </NavLink>
              )}

              {!isAuth && (
                <NavLink
                  className={s['btn-login']}
                  to={AUTH.path}
                  style={{color}}
                >
                  <p style={{color, fontSize: '0.875rem', fontWeight: 500}}>{t('signIn')}</p>
                  <span>{SVG_ICON?.LOGIN(color)}</span>
                </NavLink>
              )}

            </div>
          }
        </div>
      </header>

      <ModalOptions
        title={t('language_currency')}
        id={M_LANGUAGES_CURRENCY}
        isOpen={openModal === M_LANGUAGES_CURRENCY}
        handleClose={closeModal}
        // isLoading={true}
      >
        <HeaderSelector />
      </ModalOptions>
    </>
  )
});